<template>
  <div>
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        class="add"
        v-role="['1']"
        size="small"
        @click="upload"
      >
        <i class="el-icon-upload"></i>
        上传赛程
      </el-button>
      <el-button type="success" size="small" class="delete" @click="downLoad">
        <i class="el-icon-delete"></i>下载赛程表
      </el-button>

      <el-button
        type="danger"
        v-role="['1']"
        size="small"
        class="delete"
        @click="deleteMatch"
      >
        <i class="el-icon-delete"></i>删除
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入关键字"
              clearable
              v-model="searchForm.keyword"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="sessionName"
        min-width="200"
        align="left"
        label="场次"
      ></el-table-column>
      <el-table-column
        prop="matchTime"
        align="left"
        width="80"
        label="比赛时间"
      ></el-table-column>
      <el-table-column
        prop="fieldOrder"
        align="left"
        label="场地"
        width="80"
        :formatter="placeFormatter"
      ></el-table-column>
      <el-table-column
        prop="matchTimes"
        align="left"
        label="轮次"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="codeNumber"
        align="left"
        label="背号"
        width="80"
      ></el-table-column>
      <el-table-column
        prop="male"
        align="left"
        label="男选手"
      ></el-table-column>
      <el-table-column
        prop="female"
        align="left"
        label="女选手"
      ></el-table-column>
      <el-table-column
        prop="groupCode"
        align="center"
        label="组别代码"
      ></el-table-column>
      <el-table-column
        prop="groupName"
        align="center"
        label="组别"
      ></el-table-column>
      <el-table-column
        prop="danceType"
        align="center"
        label="舞种"
      ></el-table-column>
      <el-table-column
        prop="group"
        align="center"
        label="分组"
      ></el-table-column>
      <el-table-column
        prop="teamName"
        align="center"
        label="代表队"
      ></el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :title="'赛程导入'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form label-position="right" label-width="110px" ref="form">
        <el-upload
          ref="uploader"
          class="upload-demo"
          action=""
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :http-request="uploadFile"
          :limit="1"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传Excel文件</div>
        </el-upload>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
//import API from '../apis/matchtotal'
import API from '../apis/scheduledetail'
export default {
  props: ['matchId'],
  data () {
    return {
      multipleSelection: [],
      total: 0, dialogFormVisible: false,
      tableListData: [],
      searchForm: {
        keyword: null,
        matchId: this.matchId,
        page: 1,
        pageSize: 15,
      },
    }
  },
  methods: {
    placeFormatter (row, column) {
      //场序和场地合并成——场次
      return row.fieldOrder + (row.place==null?'':row.place)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      } else {
        return 'success-row';
      }
    },
    doSearch () {
      this.searchForm.page = 1
      this.search()
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result.data;
          this.total = result.result.recordCount;
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    }, handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    upload () {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['uploader'].clearFiles();
      })
    },
    uploadFile (item) {
      const form = new FormData();
      form.append('matchId', this.matchId);
      form.append('file1', item.file);
      API.import(form).then(res => {
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '导入成功!'
          });
          this.search()
          this.dialogFormVisible = false;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      }).catch(err => {
      })
    },
    downLoad: function () {
      API.download({ matchId: this.matchId }).then(res => {
        var content = res;
        var blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8' });
        var fileName = "赛程表.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    deleteMatch () {
      let that = this;
      this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        API.deleteMatch({ matchId: this.matchId }).then(function (result) {
          that.loading = false;
          if (result && result.code == 0) {
            that.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
            that.search()
          } else {
            that.$message.error({ showClose: true, message: '删除操作异常，请重试', duration: 2000 });
          }
        }, function (err) {
          that.loading = false;
          that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
        }).catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
        })
      })
      this.$refs.multipleTable.clearSelection()
    },
    /*批量删除*/
    delMulData () {
      let that = this;
      let val = that.multipleSelection
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() }).then(function (result) {
            that.loading = false;
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: '删除操作异常，请重试', duration: 2000 });
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.loading = false;
            console.log(error);
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    }
  }, mounted () {
    this.doSearch()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ScheduleSummary.vue